import styled from "styled-components";
import { buildColor, breakpoints } from "@tvg/design-system";
import { RaceCardContainer } from "../styled-components";

export const PoolsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  grid-row-end: span 2;
  background-color: ${buildColor("white", "900")};
  border: 1px solid ${buildColor("blue", "100")};
  border-radius: 4px;
  height: fit-content;
  justify-content: center;
  margin-bottom: 12px;

  @media screen and ${breakpoints.tablet.max.sm} {
    border: none;
  }
`;

export const ValueSwitcher = styled.div`
  width: 100%;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${buildColor("white", "900")};
  border-bottom: 1px solid ${buildColor("blue", "100")};
`;

export const ButtonsWrapper = styled.div`
  div[role="button"] {
    width: 52px;
    height: 25px;
    margin-right: 0;
    outline: none;
  }
`;

export const TableWrapper = styled.div`
  width: 100%;
`;

export const Table = styled.table`
  width: 100%;
  background-color: ${buildColor("blue_accent", "000")};
  table-layout: fixed;
`;

export const THead = styled.thead`
  border-bottom: 1px solid ${buildColor("blue", "100")};
`;

export const Th = styled.th<{
  first?: boolean;
  textCenter?: boolean;
  padding?: string;
}>`
  width: ${({ first }) => (first ? "44px" : "auto")};
  padding: ${({ padding }) => padding || `12px`};
  &,
  & p {
    text-align: ${({ textCenter }) => (textCenter ? "center" : "right")};
  }

  @supports (-moz-appearance: none) {
    @media screen and (min-width: 768px) {
      width: ${({ first }) => (first ? "44px" : "max-content")};
    }
  }
`;

export const SaddleNumberContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Tr = styled.tr<{ backgroundColor: string }>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-bottom: 1px solid ${buildColor("blue", "100")};
`;

export const Td = styled.td<{ first?: boolean }>`
  padding: 12px;
  font-family: "Roboto-Regular", sans-serif;
  text-align: ${({ first }) => (first ? "center" : "right")};
`;

export const TooltipWrapper = styled.div`
  & > div {
    display: inline-block;
  }

  &:hover {
    cursor: pointer;
  }
`;

export const TooltipContent = styled.span``;

export const SegmentedControlValue = styled.div`
  width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const EmptyMessageContainer = styled(RaceCardContainer)`
  @media screen and ${breakpoints.tablet.max.sm} {
    justify-content: center;
    flex-grow: 1;
    margin-top: 0;
    border: none;
  }
`;
